import { jsx } from 'react/jsx-runtime';
import { c as classNames } from '../theme-provider/index-chunk.esm.js';
import styles from '../styles/uitk-egds-mark.css';

const EGDSMarkTokenSizesList = [
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    24,
    30,
    37,
    38,
    40,
    48,
    72,
];
var EGDSMarkSize;
(function (EGDSMarkSize) {
    EGDSMarkSize["EXTRA_SMALL"] = "xsmall";
    EGDSMarkSize["SMALL"] = "small";
    EGDSMarkSize["MEDIUM"] = "medium";
    EGDSMarkSize["MEDIUM_LARGE"] = "mlarge";
    EGDSMarkSize["LARGE"] = "large";
})(EGDSMarkSize || (EGDSMarkSize = {}));

const getClassNameList$1 = classNames.bind(styles);
const EGDSMark = (props) => {
    const { className, url, description, id, name, size, title, shadow, orientation, lazyLoading } = props;
    const assetsBaseUrl = 'https://a.travel-assets.com/egds/marks/';
    const svgName = `${name}.svg`;
    const baseCssClass = 'uitk-mark';
    if (!name && !url) {
        console.error(`Uitk-Mark must have "name" or "url" prop`);
    }
    if (title || shadow) {
        console.error(`The following props have been deprecated from Uitk-Mark: "title", "shadow"`);
    }
    const cssClassNames = getClassNameList$1(baseCssClass, className, {
        [`${baseCssClass}-${orientation}-oriented`]: orientation,
    });
    const markCustomProps = {
        [`--uitk-mark-token-size`]: `var(--mark-size-${size})`,
    };
    const buildUrl = () => {
        if (url) {
            return url;
        }
        return `${assetsBaseUrl}${svgName}`;
    };
    const alt = description || '';
    return (jsx("img", { className: cssClassNames, alt: alt, src: buildUrl(), style: markCustomProps, id: id, loading: lazyLoading === 'off' ? undefined : lazyLoading }));
};
EGDSMark.defaultProps = {
    orientation: 'landscape',
    size: EGDSMarkSize.MEDIUM,
};
EGDSMark.displayName = 'EGDSMark';

const getClassNameList = classNames.bind(styles);
const EGDSMarkFlag = (props) => {
    const { className, description, id, name } = props;
    const assetsBaseUrl = 'https://a.travel-assets.com/egds/marks/flags/';
    const svgName = `${name?.toLowerCase()}.svg`;
    const baseCssClass = 'uitk-mark';
    const flagCssClass = 'uitk-mark-flag';
    const cssClassNames = getClassNameList(baseCssClass, className, flagCssClass);
    if (!name) {
        console.error(`Uitk-Flag must have "name" prop`);
    }
    const buildUrl = () => `${assetsBaseUrl}${svgName}`;
    const alt = description || '';
    return jsx("img", { className: cssClassNames, alt: alt, src: buildUrl(), id: id });
};
EGDSMarkFlag.displayName = 'EGDSMarkFlag';

export { EGDSMark as E, EGDSMarkFlag as a, EGDSMarkTokenSizesList as b, EGDSMarkSize as c };
//# sourceMappingURL=index-chunk.esm.js.map
